import styles from "../../styles/ActivityDetailModal.module.scss";
import {
  ActivityItemProps,
  ActivityListProps,
} from "../interfaces/ActivityInterface";
export default function ActivityDetailModal({
  closeModal,
  showActivityDetail,
}: {
  showActivityDetail: ActivityItemProps;
  closeModal: (toggleStatus: number, id: string) => void;
}) {
  function checkExistLocation(location: string) {
    let toggleLocation = 0;
    if (location) {
      toggleLocation = 0;
    } else {
      toggleLocation = 1;
    }
    return toggleLocation;
  }

  return (
    <div className={styles.activity_detail_modal}>
      <div
        className={styles.translucent_bg}
        onClick={() => closeModal(1, "1")}
      ></div>
      <div className={styles.activity_detail_bg}>
        <div className={styles.top_detail}>
          <img
            id={styles.main_img}
            src="https://i.ibb.co/1rM2wqr/momo-pic.webp"
          />
          <div className={styles.party_description}>
            <div className={styles.first_section}>
              <p className={styles.name}> {showActivityDetail.name}</p>
              <p className={styles.category}>{showActivityDetail.category}</p>
            </div>
            <div className={styles.seperated_line}> </div>
            <div className={styles.second_section}>
              <p className={styles.announce}>{showActivityDetail.announce}</p>
              <p
                className={styles.location}
                style={{
                  display: checkExistLocation(showActivityDetail.location)
                    ? "none"
                    : "flex",
                }}
              >
                {showActivityDetail.location}
              </p>
            </div>
          </div>
        </div>
        <div className={styles.activity_description}>
          <div className={styles.bullet_rectangle}> </div>
          <p className={styles.description}>{showActivityDetail.description}</p>
        </div>
        <div
          className={styles.close_button}
          onClick={() => closeModal(1, "1")}
        ></div>
      </div>
    </div>
  );
}
